<i18n lang="yaml" locale="en">
  email: E-Mail
  storage: Storage
  logout: Logout
  projects: Projects
  devices: Devices
  users: Users
</i18n>

<i18n lang="yaml" locale="de">
  email: E-Mail
  storage: Speicherplatz
  logout: Abmelden
  projects: Projekte
  devices: Geräte
  users: Nutzer
</i18n>

<template>
  <div class="manager scroll-y">
    <header>
      <img
        src="/img/logo.svg"
        class="logo"
      >
      <h1>Creator</h1>
      <template v-if="$root.$store.state.user">
        <div class="user-info">
          <span class="email">
            {{ $t('email') }}:
            <b>{{ user.email }}</b>
          </span>
          <span class="asset-usage">
            {{ $t('storage') }}:
            <b>{{ (user.used.assets || 0).toFixed(2) }} MB / {{ user.free.assets !== null ? (user.free.assets + (user.used.assets || 0)).toFixed(2) + ' MB' : '&#8734;' }}</b>
          </span>
        </div>
        <a
          class="logout"
          href="/logout"
        >
          <tw-button
            icon="user"
            color="danger"
          >{{ $t('logout') }}</tw-button>
        </a>
      </template>
    </header>
    <main v-if="$root.$store.state.user">
      <div class="navbar">
        <router-link
          v-if="user.limits.projects === null || user.limits.projects > 0"
          class="nav-link"
          to="/projects"
        >
          {{ $t('projects') }} ({{ user.used.projects || 0 }} / {{ user.free.projects !== null ? user.free.projects + (user.used.projects || 0) : '&#8734;' }})
        </router-link>
        <router-link
          v-if="user.limits.devices === null || user.limits.devices > 0"
          class="nav-link"
          to="/devices"
        >
          {{ $t('devices') }} ({{ user.used.devices || 0 }} / {{ user.free.devices !== null ? user.free.devices + (user.used.devices || 0) : '&#8734;' }})
        </router-link>
        <router-link
          v-if="user.limits.users === null || user.limits.users > 0"
          class="nav-link"
          to="/users"
        >
          {{ $t('users') }} ({{ user.used.users || 0 }} / {{ user.free.users !== null ? user.free.users + (user.used.users || 0) : '&#8734;' }})
        </router-link>
      </div>
      <router-view
        class="content"
        @dataChange="onSubmanagerDataChange"
      />
    </main>
  </div>
</template>

<script>
import Router from 'vue-router'
import ProjectManager from '@/components/ProjectManager'
import DeviceManager from '@/components/DeviceManager'
import UserManager from '@/components/UserManager'
import TwButton from '@/components/ui/TwButton'
import axios from 'axios'

export default {
  name: 'Manager',
  components: {
    TwButton
  },
  router: new Router({
    routes: [
      {
        path: '/projects',
        component: ProjectManager
      },
      {
        path: '/devices',
        component: DeviceManager
      },
      {
        path: '/users',
        component: UserManager
      },
      {
        path: '/',
        redirect: '/projects'
      }
    ]
  }),
  computed: {
    user () {
      return this.$root.$store.state.user
    }
  },
  methods: {
    async onSubmanagerDataChange () {
      const resp = await axios.get('/users/' + this.user._id)
      this.$root.$store.dispatch('setUser', { user: resp.data })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.manager {
  color: #fff;
  background: $color-main-darker url('/img/background.jpg') 0 0 no-repeat;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  font-size: 18px;
  line-height: 1.5;
  letter-spacing: 0.2pt;

  header {
    display: flex;
    align-items:flex-end;
    background-color: #fff;
    padding: 32px;
    box-shadow: 0 0 10px rgba($color: #000, $alpha: 0.35);

    .logo {
      width: 210px;
    }

    h1 {
      font-size: 32px;
      line-height: 0.9em;
      color: $color-main-darker;
      font-weight: 500;
      margin-left: 4px;
      margin-bottom: 0;
      letter-spacing: -1px;
    }

    .user-info {
      margin-left: auto;
      padding-left: 20px;

      .email {
        color: $color-main-darker;
        display: block;
      }

      .asset-usage {
        color: $color-main-darker;
        font-size: 0.8em;
      }
    }

    .logout {
      margin-left: 40px;
    }
  }

  main {
    padding: 32px;
  }

  .navbar {
    display: flex;
    border-bottom: 1px solid #fff;
    font-weight: 700;
    text-transform: uppercase;

    .nav-link {
      margin-right: 32px;
      padding: 10px 0;

      &:hover {
        border-bottom: 4px solid #fff;
      }

      &.router-link-exact-active {
        border-bottom: 4px solid #fff;
      }
    }
  }

  /deep/ table {
    width: 100%;
    border-collapse: collapse;
    margin: 32px 0 48px;

    thead {
      tr {
        border-bottom: 1px solid rgba($color: #fff, $alpha: 0.25);
      }

      tr th:last-of-type {
        text-align: right;
      }

      th {
        padding: 15px 0;
        text-align: left;
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid rgba($color: #fff, $alpha: 0.25);

        &:hover {
          border-color: rgba($color: #fff, $alpha: 1.0);
        }
      }

      tr td:last-of-type {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        svg {
          margin-left: 20px;
          margin-top: 2px;
        }
      }

      td {
        padding: 14px 0;

        > a {
          border-bottom: 2px solid transparent;

          &:hover {
            border-color: #fff;
          }
        }
      }
    }
  }
}
</style>
